import { formatInTimeZone } from 'date-fns-tz'
import { ptBR } from 'date-fns/locale'

// Decisão 52 (nota [CC][F-receita-codigo-acesso]): `recipe.emission` chega
// em ISO/UTC do banco (ex. "2025-05-02T12:25:18.000Z") — formatar sem
// converter fuso mostraria a hora errada pro paciente. `formatInTimeZone`
// (`date-fns-tz`, já usado em `services/resources/products/serializers.ts`
// e `CalendarioOnboarding`) converte pra America/Sao_Paulo antes de
// formatar. UMA função só, reusada em D1 (`RecipeAccessScreen`), D3
// (`ReceiptCard`) e D4 (`RecipeProductsScreen`) — não é a mesma coisa que
// `delivery.estimated_delivery_range_start/end`, que são datas de
// calendário (sem hora) e não devem levar esse ajuste de fuso.
export function formatRecipeDateTime(iso: string): string {
  if (!iso) return ''
  try {
    return formatInTimeZone(iso, 'America/Sao_Paulo', 'dd/MM/yyyy HH:mm', { locale: ptBR })
  } catch {
    return iso
  }
}
